import React, {useContext, useEffect} from "react";
import {RouteDetailContext} from "./context/RouteDetailContext";
import Column from "@amzn/meridian/column";
import Tab, {TabGroup} from "@amzn/meridian/tab";
import {FormattedMessage} from "react-intl";
import {getPicklistTab} from "../util/EntityStatusManager";

const PicklistTabSelector = () => {
    const {viewModelRD, dispatchRD} = useContext(RouteDetailContext);

    const getPicklistTabs = (picklists) =>
        Array.from(new Set(picklists.map(getPicklistTab)));

    const pickListTabs = getPicklistTabs(viewModelRD.picklists || []);

    const changePicklistTab = (newTab) => {
        dispatchRD({type: 'CHANGE_PICKLIST_TAB', data: {selectedPicklistTab: newTab}});
    };

    useEffect(() => {
        if (!viewModelRD.selectedPicklistTab && pickListTabs.length > 0) {
            changePicklistTab(pickListTabs[0]);
        }
    }, [viewModelRD.selectedPicklistTab, pickListTabs]);

    return (
        <Column>
            <TabGroup value={viewModelRD.selectedPicklistTab} onChange={changePicklistTab}>
                {pickListTabs.map((tab) => (
                    <Tab key={tab} value={tab}>
                        <FormattedMessage
                            id={`routeInfo.picklist.${tab.toLowerCase()}`}
                            defaultMessage={tab}
                        />
                    </Tab>
                ))}
            </TabGroup>
        </Column>
    );
};

export default PicklistTabSelector;


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/PicklistTabSelector.js